import React from 'react';
import PageHeader from './global-components/page-header';
import ContactFormThanks from './section-components/contact-form-thanks';
import Map from './section-components/map';
import MainLayout from 'components/layouts/MainLayout';

const ContactV1 = () => {
    return <div>
        <MainLayout>
        <PageHeader customclass="mb-5" headertitle="CUÉNTANOS TU IDEA" subheader="Gracias" />
        <ContactFormThanks />
        <Map />
        </ MainLayout>
    </div>
}

export default ContactV1

